import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { InstitutionsServicesGetRequestModel, InstitutionsServicesGetResponseModel } from "@/features/institutions/services/institutions-services-model";

export class InstitutionsServicesApi {
  /**
   * 金融機関サービス一覧取得
   */
  public getInstitutionsServices = async (
    param: InstitutionsServicesGetRequestModel
  ): Promise<InstitutionsServicesGetResponseModel[]> => {
    const path = `/api/institutions/services`;
    const res = await ApiClient.instance.get<InstitutionsServicesGetResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
